import capitalizeFirstLetterOfWord from "./capitalizeFirstLetterOfWord";

const convertCamelCaseToCapitalize = (value) =>
  capitalizeFirstLetterOfWord(value).replace(/([a-z])([A-Z])/g, "$1 $2");

export default convertCamelCaseToCapitalize;
